<!-- Toolbar -->
<p-toolbar class="p-mb-3">
  <!-- Left Group: Settings Management -->
  <div class="p-toolbar-group-left">
    <p-button
      label="Expand"
      icon="pi pi-chevron-circle-down"
      class="p-button-secondary mr-3"
      (click)="expandAllUsedTabs()"
    ></p-button>

    <p-button
      label="Collapse"
      icon="pi pi-chevron-circle-up
"
      class="p-button-secondary mr-3"
      (click)="collapseAllTabs()"
    ></p-button>

    <p-button
      label="New"
      icon="pi pi-file"
      class="p-button-secondary mr-3"
      (click)="startWithNewSettings()"
      pTooltip="Start with default settings"
    ></p-button>
    <p-button
      label="Load"
      icon="pi pi-folder-open"
      class="mr-3"
      (click)="openLoadSettingsDialog()"
      pTooltip="Load saved settings"
    ></p-button>
  </div>

  <!-- Center Group: Save Operations -->
  <div class="p-toolbar-group-center">
    <p-button
      label="Save"
      icon="pi pi-save"
      (click)="saveSettings()"
      [disabled]="!isModified"
      pTooltip="Save changes"
    ></p-button>
  </div>

  <!-- Right Group: Editing Tools -->
  <div class="p-toolbar-group-right">
    <p-button
      label="Reset"
      icon="pi pi-undo"
      class="p-button-warning mr-3"
      (click)="resetToOriginalSettings()"
      [disabled]="!isModified"
      pTooltip="Reset changes"
    ></p-button>
    <!-- Display Loaded Settings Info -->
    <span *ngIf="loadedSettingName" class="p-mr-2 loaded-settings">
      <i class="pi pi-cog"></i>
      {{ loadedSettingName }}
      <span *ngIf="currentSettingVersion">(v{{ currentSettingVersion }})</span>
    </span>
    <!-- Modified Indicator -->
    <span *ngIf="isModified" class="p-mr-2 modified-indicator">
      <i class="pi pi-info-circle"></i>
      Modified
    </span>
  </div>
</p-toolbar>

<!-- Save Settings Dialog -->
<p-dialog
  header="Save Settings"
  [(visible)]="showSaveSettingsDialog"
  [modal]="true"
  [style]="{ width: '400px' }"
  [closable]="false"
>
  <div class="p-fluid">
    <div class="field">
      <label for="settingName">Setting Name</label>
      <input id="settingName" name="settingName" type="text" pInputText [(ngModel)]="newSetting.name" />
    </div>
    <div class="field-checkbox">
      <p-checkbox inputId="isDefault" [(ngModel)]="newSetting.isDefault" binary="true"></p-checkbox>
      <label for="isDefault">Set as default</label>
    </div>
  </div>
  <div class="flex justify-content-end gap-2">
    <p-button label="Cancel" (click)="showSaveSettingsDialog = false"></p-button>
    <p-button label="Save" class="" (click)="confirmSaveSettings()"></p-button>
  </div>
</p-dialog>

<!-- Load Settings Dialog -->
<p-dialog
  header="Load Settings"
  [(visible)]="showLoadSettingsDialog"
  [modal]="true"
  [style]="{ width: '600px' }"
  [closable]="false"
>
  <p-table [value]="savedSettings" selectionMode="single" [(selection)]="selectedSetting" [paginator]="true" [rows]="5">
    <ng-template pTemplate="header">
      <tr>
        <th>Name</th>
        <th>Version</th>
        <th>Previous Version</th>
        <th>Created At</th>
        <th>Actions</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-setting>
      <tr [pSelectableRow]="setting">
        <td>{{ setting.name }}</td>
        <td>{{ setting.version }}</td>
        <td>
          {{ getVersionById(setting.previousVersionId)?.version || 'N/A' }}
        </td>
        <td>{{ setting.createdAt.toString() | date: 'short' }}</td>
        <td>
          <p-button icon="pi pi-eye" severity="info" class="mr-2" (click)="previewSettings(setting)"></p-button>
          <p-button icon="pi pi-trash" severity="danger" (click)="deleteSetting(setting.id)"></p-button>
        </td>
      </tr>
    </ng-template>
  </p-table>
  <div class="flex justify-content-end gap-2">
    <p-button label="Cancel" class="mr-2" (click)="showLoadSettingsDialog = false"></p-button>
    <p-button label="Load" class="" [disabled]="!selectedSetting" (click)="confirmLoadSettings()"></p-button>
  </div>
</p-dialog>

<!-- Preview Settings Dialog -->
<p-dialog header="Settings Preview" [(visible)]="showPreviewSettingsDialog" [modal]="true" [style]="{ width: '600px' }">
  <pre>{{ selectedSetting | json }}</pre>
  <div class="flex justify-content-end gap-2">
    <p-button label="Close" (click)="showPreviewSettingsDialog = false"></p-button>
  </div>
</p-dialog>

<!-- 
  Updated p-accordion using the new structure:
  - [multiple]="true" means multiple panels can be opened at the same time.
  - [value]="openPanels" is an array of panel identifiers you want expanded.
  - Each <p-accordion-panel> sets a unique value="someId" to match the array entries.
-->
<div class="grid" *ngIf="lendPeak">
  <div class="col-12">
    <p-accordion [multiple]="true" [value]="openPanels">
      <!-- Interest Rate -->
      <p-accordion-panel value="interestRate">
        <p-accordion-header>
          <div>
            <p-badge
              class="mr-4"
              badgeSize="xlarge"
              [severity]="lendPeak.amortization.rateSchedules.allCustom.length > 0 ? 'contrast' : 'secondary'"
              [value]="lendPeak.amortization.rateSchedules.allCustom.length"
            />

            Date Range Interest Rate
          </div>
        </p-accordion-header>
        <p-accordion-content>
          <div class="p-fluid">
            <table *ngIf="lendPeak.amortization.rateSchedules.allCustom.length > 0" class="p-datatable p-component">
              <thead>
                <tr>
                  <th>Start Date</th>
                  <th>End Date</th>
                  <th>Interest Rate (%)</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let rate of lendPeak.amortization.rateSchedules.allCustom; let i = index">
                  <!-- Start Date -->
                  <td>
                    <p-datepicker
                      [(ngModel)]="rate.jsStartDate"
                      name="overrideStartDate-{{ i }}"
                      dateFormat="yy-mm-dd"
                      showIcon
                      (ngModelChange)="onInputChange($event)"
                      appendTo="body"
                    >
                      <ng-template pTemplate="date" let-date>
                        <span
                          [ngStyle]="
                            isPeriodEndDate(date)
                              ? {
                                  backgroundColor: 'orange',
                                  color: 'white',
                                  borderRadius: '50%',
                                  padding: '5px',
                                  display: 'inline-block',
                                  textAlign: 'center',
                                  width: '24px',
                                }
                              : {}
                          "
                        >
                          {{ date.day }}
                        </span>
                      </ng-template>
                    </p-datepicker>
                  </td>
                  <!-- End Date -->
                  <td>
                    <p-datepicker
                      appendTo="body"
                      [(ngModel)]="rate.jsEndDate"
                      name="overrideEndDate-{{ i }}"
                      dateFormat="yy-mm-dd"
                      showIcon
                      (ngModelChange)="onInputChange($event)"
                    >
                      <ng-template pTemplate="date" let-date>
                        <span
                          [ngStyle]="
                            isPeriodEndDate(date)
                              ? {
                                  backgroundColor: 'orange',
                                  color: 'white',
                                  borderRadius: '50%',
                                  padding: '5px',
                                  display: 'inline-block',
                                  textAlign: 'center',
                                  width: '24px',
                                }
                              : {}
                          "
                        >
                          {{ date.day }}
                        </span>
                      </ng-template>
                    </p-datepicker>
                  </td>
                  <!-- Interest Rate -->
                  <td>
                    <p-inputNumber
                      [(ngModel)]="rate.jsAnnualInterestRate"
                      name="overrideInterestRate-{{ i }}"
                      mode="decimal"
                      minFractionDigits="2"
                      suffix="%"
                      (ngModelChange)="onInputChange($event)"
                    ></p-inputNumber>
                  </td>
                  <!-- Remove Button -->
                  <td>
                    <p-button
                      icon="pi pi-trash"
                      class="p-button-rounded"
                      severity="danger"
                      (click)="removeRateOverride(rate.id)"
                    ></p-button>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="p-mt-2">
              <p-button label="Add New Rate Row" icon="pi pi-plus" (click)="addRateOverride()"></p-button>
            </div>
          </div>
        </p-accordion-content>
      </p-accordion-panel>
      <p-accordion-panel value="termCalendarOverride">
        <p-accordion-header>
          <div>
            <p-badge
              class="mr-4"
              badgeSize="xlarge"
              [severity]="lendPeak.amortization.calendars.length > 0 ? 'contrast' : 'secondary'"
              [value]="lendPeak.amortization.calendars.length"
            />
            Term Calendar Override
          </div>
        </p-accordion-header>
        <p-accordion-content>
          <div class="p-fluid">
            <!-- TERM CALENDAR OVERRIDE TABLE -->
            <p-table
              [value]="lendPeak!.amortization.calendars.all"
              dataKey="jsTermNumber"
              editMode="row"
              class="p-datatable p-component"
            >
              <!-- HEADER -->
              <ng-template #header>
                <tr>
                  <th style="width: 3rem">
                    <p-toggleswitch
                      [(ngModel)]="tcoMasterActive"
                      (ngModelChange)="toggleAllTermCalendarOverrides($event)"
                    ></p-toggleswitch>
                  </th>

                  <th>Period Start</th>
                  <th>Period End</th>
                  <th>Term&nbsp;#</th>
                  <th>Calendar</th>
                  <th style="width: 9rem">Actions</th>
                </tr>
              </ng-template>

              <!-- BODY -->
              <ng-template #body let-row let-editing="editing" let-ri="rowIndex">
                <tr
                  [pEditableRow]="row"
                  [ngClass]="{
                    'bg-red-50': lendPeak!.amortization.calendars.isDuplicateTermNumber(row.jsTermNumber),
                    'opacity-40': !row.active,
                  }"
                >
                  <!-- row toggle (always visible) -->
                  <td>
                    <p-toggleswitch [(ngModel)]="row.active" (ngModelChange)="onInputChange($event)"></p-toggleswitch>
                  </td>

                  <!-- Period dates – read-only -->
                  <td>
                    {{ getStartDateForTerm(row.jsTermNumber).toString() | date: 'yyyy-MM-dd' }}
                  </td>
                  <td>
                    {{ getEndDateForTerm(row.jsTermNumber).toString() | date: 'yyyy-MM-dd' }}
                  </td>

                  <!-- Term # – editable -->
                  <td pEditableColumn>
                    <p-cellEditor>
                      <ng-template #output>{{ row.jsTermNumber }}</ng-template>
                      <ng-template #input>
                        <p-inputNumber [(ngModel)]="row.jsTermNumber"></p-inputNumber>
                      </ng-template>
                    </p-cellEditor>
                  </td>

                  <!-- Calendar Type – editable -->
                  <td pEditableColumn>
                    <p-cellEditor>
                      <ng-template #output>{{ row.calendar.userFriendlyName }}</ng-template>
                      <ng-template #input>
                        <p-select
                          [options]="calendarTypes"
                          [(ngModel)]="row.calendar.calendarType"
                          appendTo="body"
                        ></p-select>
                      </ng-template>
                    </p-cellEditor>
                  </td>

                  <!-- ACTIONS -->
                  <td class="text-center" style="width: 9rem">
                    <div class="flex items-center justify-center gap-2">
                      <!-- view mode -->
                      <button
                        *ngIf="!editing"
                        pButton
                        pRipple
                        text
                        rounded
                        severity="secondary"
                        pInitEditableRow
                        icon="pi pi-pencil"
                        (click)="onTcoEditInit(row)"
                        pTooltip="Edit row"
                      ></button>

                      <button
                        *ngIf="!editing"
                        pButton
                        pRipple
                        text
                        rounded
                        severity="danger"
                        icon="pi pi-trash"
                        (click)="removeTermCalendarOverride(ri)"
                        pTooltip="Remove row"
                      ></button>

                      <!-- edit mode -->
                      <button
                        *ngIf="editing"
                        pButton
                        pRipple
                        rounded
                        severity="success"
                        pSaveEditableRow
                        icon="pi pi-check"
                        (click)="onTcoEditSave(row)"
                        pTooltip="Save"
                      ></button>

                      <button
                        *ngIf="editing"
                        pButton
                        pRipple
                        rounded
                        severity="secondary"
                        pCancelEditableRow
                        icon="pi pi-times"
                        (click)="onTcoEditCancel(row, ri)"
                        pTooltip="Cancel"
                      ></button>
                    </div>
                  </td>
                </tr>
              </ng-template>
            </p-table>

            <div class="p-mt-2">
              <p-divider></p-divider>

              <p-button
                class="pr-2"
                label="Add Calendar Override"
                icon="pi pi-plus"
                (click)="addTermCalendarOverrideRow()"
              ></p-button>
              <p-button
                class="pr-2"
                severity="info"
                label="Re-Sort"
                icon="pi pi-refresh"
                (click)="refreshSortForTermCalendarOverride()"
              ></p-button>

              <p-button
                severity="danger"
                label="Remove All"
                icon="pi pi-trash"
                (click)="removeAllTermCalendarOverride()"
              ></p-button>
            </div>
          </div>
        </p-accordion-content>
      </p-accordion-panel>

      <!-- Term Interest Amount Override -->
      <p-accordion-panel value="termInterestOverride">
        <p-accordion-header>
          <div>
            <p-badge
              class="mr-4"
              badgeSize="xlarge"
              [severity]="lendPeak.amortization.termInterestAmountOverride.length > 0 ? 'contrast' : 'secondary'"
              [value]="lendPeak.amortization.termInterestAmountOverride.length"
            />
            Term Interest Amount Override
          </div>
        </p-accordion-header>
        <p-accordion-content>
          <div class="p-fluid">
            <!-- TERM INTEREST AMOUNT OVERRIDE TABLE -->
            <p-table
              [value]="lendPeak!.amortization.termInterestAmountOverride.all"
              dataKey="jsTermNumber"
              editMode="row"
              class="p-datatable p-component"
            >
              <!-- ─── HEADER ───────────────────────────────────────────── -->
              <ng-template #header>
                <tr>
                  <th style="width: 3rem">
                    <p-toggleswitch
                      [(ngModel)]="tiaoMasterActive"
                      (ngModelChange)="toggleAllTiao($event)"
                    ></p-toggleswitch>
                  </th>
                  <th>Start</th>
                  <th>End</th>
                  <th>Term&nbsp;#</th>
                  <th>Interest&nbsp;Amt</th>
                  <th>Rate&nbsp;Variance</th>
                  <th>Rate&nbsp;(%)</th>
                  <th style="width: 9rem">Actions</th>
                </tr>
              </ng-template>

              <!-- ─── BODY ─────────────────────────────────────────────── -->
              <ng-template #body let-row let-editing="editing" let-ri="rowIndex">
                <tr
                  [pEditableRow]="row"
                  [ngClass]="{
                    'opacity-40': !row.active,
                    'bg-red-50': lendPeak!.amortization.termInterestAmountOverride.isDuplicateTermNumber(
                      row.jsTermNumber
                    ),
                  }"
                >
                  <!-- active toggle -->
                  <td>
                    <p-toggleswitch [(ngModel)]="row.active" (ngModelChange)="onInputChange($event)"></p-toggleswitch>
                  </td>

                  <!-- dates (read-only) -->
                  <td>
                    {{ getStartDateForTerm(row.jsTermNumber).toString() | date: 'yyyy-MM-dd' }}
                  </td>
                  <td>
                    {{ getEndDateForTerm(row.jsTermNumber).toString() | date: 'yyyy-MM-dd' }}
                  </td>

                  <!-- term # (editable) -->
                  <td pEditableColumn>
                    <p-cellEditor>
                      <ng-template #output>{{ row.jsTermNumber }}</ng-template>
                      <ng-template #input>
                        <p-inputNumber [(ngModel)]="row.jsTermNumber"></p-inputNumber>
                      </ng-template>
                    </p-cellEditor>
                  </td>

                  <!-- interest amount (editable) -->
                  <td pEditableColumn>
                    <p-cellEditor>
                      <ng-template #output>{{ row.jsInterestAmount.toFixed(2) }}</ng-template>
                      <ng-template #input>
                        <p-inputNumber
                          [(ngModel)]="row.jsInterestAmount"
                          mode="decimal"
                          locale="en-US"
                          [minFractionDigits]="2"
                          [maxFractionDigits]="2"
                        ></p-inputNumber>
                      </ng-template>
                    </p-cellEditor>
                  </td>

                  <!-- variance (editable) -->
                  <td pEditableColumn>
                    <p-cellEditor>
                      <ng-template #output>{{ row.jsAcceptableRateVariance * 100 | number: '1.2-4' }} %</ng-template>
                      <ng-template #input>
                        <p-inputNumber
                          [(ngModel)]="row.jsAcceptableRateVariance"
                          mode="decimal"
                          locale="en-US"
                          [minFractionDigits]="4"
                          [maxFractionDigits]="10"
                        ></p-inputNumber>
                      </ng-template>
                    </p-cellEditor>
                  </td>

                  <!-- computed rate (read-only) -->
                  <!-- Rate (%) – read-only, with warning icon -->
                  <td>
                    <ng-container *ngIf="row.active; else NA">
                      <!-- warning icon (shown only when threshold exceeded) -->
                      <i
                        *ngIf="
                          lendPeak!.amortization.repaymentSchedule.getEntryByTerm(row.jsTermNumber)?.metadata
                            ?.equivalentAnnualRateVarianceExceeded
                        "
                        class="pi pi-exclamation-triangle text-red-500 mr-1"
                        style="font-size: 1.4rem"
                        pTooltip="
        WARNING: Equivalent annual rate variance for this term is
        {{
                          lendPeak!.amortization.repaymentSchedule.getEntryByTerm(row.jsTermNumber)?.metadata
                            ?.equivalentAnnualRateVariance | percent: '1.2-4'
                        }},
        which exceeds the acceptable threshold
        {{ row.jsAcceptableRateVariance | percent: '1.2-4' }}.
      "
                        tooltipPosition="left"
                      ></i>

                      <!-- always show the calculated rate value -->
                      {{
                        lendPeak!.amortization.repaymentSchedule.getEntryByTerm(row.jsTermNumber)?.jsPeriodInterestRate
                          | percent: '1.2-4'
                      }}
                    </ng-container>

                    <!-- row is inactive -->
                    <ng-template #NA>N/A</ng-template>
                  </td>

                  <!-- ACTIONS -->
                  <td class="text-center" style="width: 9rem">
                    <div class="flex items-center justify-center gap-2">
                      <!-- view mode -->
                      <button
                        *ngIf="!editing"
                        pButton
                        pRipple
                        text
                        rounded
                        severity="secondary"
                        pInitEditableRow
                        icon="pi pi-pencil"
                        (click)="onTiaoEditInit(row)"
                        pTooltip="Edit row"
                      ></button>

                      <button
                        *ngIf="!editing"
                        pButton
                        pRipple
                        text
                        rounded
                        severity="danger"
                        icon="pi pi-trash"
                        (click)="removeTermInterestOverride(ri)"
                        pTooltip="Remove row"
                      ></button>

                      <!-- edit mode -->
                      <button
                        *ngIf="editing"
                        pButton
                        pRipple
                        rounded
                        severity="success"
                        pSaveEditableRow
                        icon="pi pi-check"
                        (click)="onTiaoEditSave(row)"
                        pTooltip="Save"
                      ></button>

                      <button
                        *ngIf="editing"
                        pButton
                        pRipple
                        rounded
                        severity="secondary"
                        pCancelEditableRow
                        icon="pi pi-times"
                        (click)="onTiaoEditCancel(row, ri)"
                        pTooltip="Cancel"
                      ></button>
                    </div>
                  </td>
                </tr>
              </ng-template>
            </p-table>

            <div class="p-mt-2">
              <p-divider></p-divider>

              <p-button
                class="pr-2"
                label="Add Interest Override"
                icon="pi pi-plus"
                (click)="addTermInterestOverrideRow()"
              ></p-button>
              <p-button
                class="pr-2"
                severity="info"
                label="Re-Sort"
                icon="pi pi-refresh"
                (click)="refreshSortForTermInterestOverride()"
              ></p-button>

              <p-button
                severity="danger"
                label="Remove All"
                icon="pi pi-trash"
                (click)="removeAllTermInterestOverride()"
              ></p-button>
            </div>
          </div>
        </p-accordion-content>
      </p-accordion-panel>

      <!-- Term Interest Rate Override -->
      <!-- ─── Term Interest-Rate Override (per-term rate) ──────────────────── -->
      <p-accordion-panel value="termInterestRateOverride">
        <p-accordion-header>
          <div>
            <p-badge
              class="mr-4"
              badgeSize="xlarge"
              [severity]="lendPeak.amortization.termInterestRateOverride.length ? 'contrast' : 'secondary'"
              [value]="lendPeak.amortization.termInterestRateOverride.length"
            ></p-badge>
            Term Interest-Rate Override
          </div>
        </p-accordion-header>

        <p-accordion-content>
          <p-table
            [value]="lendPeak!.amortization.termInterestRateOverride.all"
            dataKey="jsTermNumber"
            editMode="row"
            class="p-datatable p-component"
          >
            <!-- header -->
            <ng-template pTemplate="header">
              <tr>
                <th style="width: 3rem">
                  <p-toggleswitch
                    [(ngModel)]="tiroMasterActive"
                    (ngModelChange)="toggleAllTiro($event)"
                  ></p-toggleswitch>
                </th>
                <th>Start</th>
                <th>End</th>
                <th>Term&nbsp;#</th>
                <th>Rate&nbsp;%</th>
                <th style="width: 9rem">Actions</th>
              </tr>
            </ng-template>

            <!-- body -->
            <ng-template pTemplate="body" let-row let-editing="editing" let-ri="rowIndex">
              <tr
                [pEditableRow]="row"
                [ngClass]="{
                  'opacity-40': !row.active,
                  'bg-red-50': lendPeak!.amortization.termInterestRateOverride.isDuplicateTermNumber(row.jsTermNumber),
                }"
              >
                <!-- active toggle -->
                <td>
                  <p-toggleswitch [(ngModel)]="row.active" (ngModelChange)="onInputChange($event)"></p-toggleswitch>
                </td>

                <!-- dates (read-only) -->
                <td>
                  {{ getStartDateForTerm(row.jsTermNumber).toString() | date: 'yyyy-MM-dd' }}
                </td>
                <td>
                  {{ getEndDateForTerm(row.jsTermNumber).toString() | date: 'yyyy-MM-dd' }}
                </td>

                <!-- term # (editable) -->
                <td pEditableColumn>
                  <p-cellEditor>
                    <ng-template #output>{{ row.jsTermNumber }}</ng-template>
                    <ng-template #input>
                      <p-inputNumber [(ngModel)]="row.jsTermNumber"></p-inputNumber>
                    </ng-template>
                  </p-cellEditor>
                </td>

                <!-- rate % (editable – store as DECIMAL, display %) -->
                <td pEditableColumn>
                  <p-cellEditor>
                    <ng-template #output>
                      {{ row.jsInterestRate | number: '1.4-8' }}
                    </ng-template>
                    <ng-template #input>
                      <p-inputNumber
                        [(ngModel)]="row.jsInterestRate"
                        mode="decimal"
                        [minFractionDigits]="4"
                        [maxFractionDigits]="8"
                        suffix="%"
                      ></p-inputNumber>
                    </ng-template>
                  </p-cellEditor>
                </td>

                <!-- row actions -->
                <td class="text-center" style="width: 9rem">
                  <div class="flex items-center justify-center gap-2">
                    <!-- view -->
                    <button
                      *ngIf="!editing"
                      pButton
                      pRipple
                      text
                      rounded
                      severity="secondary"
                      pInitEditableRow
                      icon="pi pi-pencil"
                      (click)="onTiroEditInit(row)"
                    ></button>
                    <button
                      *ngIf="!editing"
                      pButton
                      pRipple
                      text
                      rounded
                      severity="danger"
                      icon="pi pi-trash"
                      (click)="removeTermInterestRateOverride(ri)"
                    ></button>

                    <!-- edit -->
                    <button
                      *ngIf="editing"
                      pButton
                      pRipple
                      rounded
                      severity="success"
                      pSaveEditableRow
                      icon="pi pi-check"
                      (click)="onTiroEditSave(row)"
                    ></button>
                    <button
                      *ngIf="editing"
                      pButton
                      pRipple
                      rounded
                      severity="secondary"
                      pCancelEditableRow
                      icon="pi pi-times"
                      (click)="onTiroEditCancel(row, ri)"
                    ></button>
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>

          <div class="p-mt-2">
            <p-divider></p-divider>

            <p-button label="Add Rate Override" icon="pi pi-plus" (click)="addTermInterestRateOverrideRow()"></p-button>

            <p-button
              label="Re-Sort"
              class="ml-2"
              severity="info"
              icon="pi pi-refresh"
              (click)="refreshSortForTermInterestOverride()"
            ></p-button>

            <p-button
              label="Remove All"
              class="ml-2"
              severity="danger"
              icon="pi pi-trash"
              (click)="removeAllTermInterestOverride()"
            ></p-button>
          </div>
        </p-accordion-content>
      </p-accordion-panel>

      <!-- Payoff Settings Section -->
      <p-accordion-panel value="payoffConfiguration">
        <p-accordion-header>
          <div>
            <p-badge
              class="mr-4"
              badgeSize="xlarge"
              [severity]="lendPeak.amortization.jsPayoffDate ? 'contrast' : 'secondary'"
              [value]="lendPeak.amortization.jsPayoffDate ? 1 : 0"
            />
            Payoff Configuration
          </div>
        </p-accordion-header>
        <p-accordion-content>
          <div class="grid">
            <!-- Payoff Date-->
            <div class="col">
              <label for="payoffDate">
                Payoff Date
                <i class="pi pi-info-circle tooltip-icon" (click)="showTooltip($event, jsPayoffDate)"></i>
              </label>

              <p-datepicker
                [(ngModel)]="lendPeak.amortization.jsPayoffDate"
                inputId="payoffDate"
                dateFormat="yy-mm-dd"
                showIcon
                [showButtonBar]="true"
                appendTo="body"
                [minDate]="lendPeak.amortization.jsStartDate"
                [maxDate]="lendPeak.amortization.jsEndDate"
                [numberOfMonths]="3"
                (ngModelChange)="onInputChange($event)"
                appendTo="body"
              ></p-datepicker>

              <!-- Tooltip Overlay -->
              <p-popover #jsPayoffDate>
                <ng-template pTemplate="content">
                  Payoff Date is the date when the loan is paid off in full. System will alter billing cycle to ensure
                  the loan is paid off on this date.
                </ng-template>
              </p-popover>
            </div>
          </div>
        </p-accordion-content>
      </p-accordion-panel>

      <!-- Payment Settings Section -->
      <p-accordion-panel value="paymentSettings">
        <p-accordion-header>
          <div>
            <p-badge
              class="mr-4"
              badgeSize="xlarge"
              [severity]="lendPeak.amortization.jsHasCustomEquitedMonthlyPayment ? 'contrast' : 'secondary'"
              [value]="lendPeak.amortization.jsHasCustomEquitedMonthlyPayment ? 1 : 0"
            />
            Equated Installment Payments (EIP)
          </div>
        </p-accordion-header>
        <p-accordion-content>
          <div class="p-fluid">
            <div class="field">
              <label for="jsEquitedMonthlyPayment">
                Term Payment Amount
                <i class="pi pi-info-circle tooltip-icon" (click)="showTooltip($event, termPaymentAmountTooltip)"></i>
              </label>
              <p-inputgroup>
                <p-inputgroup-addon>
                  <p-checkbox
                    [(ngModel)]="lendPeak.amortization.jsHasCustomEquitedMonthlyPayment"
                    (ngModelChange)="onInputChange($event)"
                    binary="true"
                    inputId="hasCustomEquitedMonthlyPayment"
                    size="small"
                  ></p-checkbox>
                </p-inputgroup-addon>
                <p-inputgroup-addon>$</p-inputgroup-addon>

                <p-inputNumber
                  inputId="jsEquitedMonthlyPayment"
                  [(ngModel)]="lendPeak.amortization.jsEquitedMonthlyPayment"
                  mode="decimal"
                  [minFractionDigits]="2"
                  [maxFractionDigits]="2"
                  [disabled]="!lendPeak.amortization.hasCustomEquitedMonthlyPayment"
                  (ngModelChange)="onInputChange($event)"
                ></p-inputNumber>
              </p-inputgroup>

              <!-- Tooltip Overlay -->
              <p-popover #termPaymentAmountTooltip>
                <ng-template pTemplate="content">
                  Override the calculated payment amount per term. For example, enter "$1,200" to set a fixed payment
                  amount.
                </ng-template>
              </p-popover>
            </div>
          </div>
        </p-accordion-content>
      </p-accordion-panel>

      <!-- Term Payment Amount -->
      <p-accordion-panel value="termPaymentAmount">
        <p-accordion-header>
          <div>
            <p-badge
              class="mr-4"
              badgeSize="xlarge"
              [severity]="lendPeak.amortization.termPaymentAmountOverride.length > 0 ? 'contrast' : 'secondary'"
              [value]="lendPeak.amortization.termPaymentAmountOverride.length"
            />
            Term Payment Amount
          </div>
        </p-accordion-header>
        <p-accordion-content>
          <div class="p-fluid">
            <!-- TERM PAYMENT AMOUNT OVERRIDE TABLE -->
            <p-table
              [value]="lendPeak!.amortization.termPaymentAmountOverride.all"
              dataKey="jsTermNumber"
              editMode="row"
              class="p-datatable p-component"
            >
              <!-- HEADER -->
              <ng-template #header>
                <tr>
                  <th style="width: 3rem">
                    <p-toggleswitch [(ngModel)]="tpaMasterActive"></p-toggleswitch>
                  </th>
                  <th>Period Start</th>
                  <th>Period End</th>
                  <th>Term&nbsp;#</th>
                  <th>Payment&nbsp;Amt</th>
                  <th style="width: 9rem">Actions</th>
                </tr>
              </ng-template>

              <!-- BODY -->
              <ng-template #body let-row let-editing="editing" let-ri="rowIndex">
                <tr
                  [pEditableRow]="row"
                  [ngClass]="{
                    'bg-red-50':
                      lendPeak!.amortization.termPaymentAmountOverride.isDuplicateTermNumber(row.jsTermNumber) ||
                      row.jsTermNumber >= lendPeak!.amortization.repaymentSchedule.lastEntry.term,
                    'opacity-40': !row.active,
                  }"
                >
                  <!-- row toggle -->
                  <td>
                    <p-toggleswitch [(ngModel)]="row.active" (ngModelChange)="onInputChange($event)"></p-toggleswitch>
                  </td>

                  <!-- dates (read-only) -->
                  <td>
                    {{ getStartDateForTerm(row.jsTermNumber).toString() | date: 'yyyy-MM-dd' }}
                  </td>
                  <td>
                    {{ getEndDateForTerm(row.jsTermNumber).toString() | date: 'yyyy-MM-dd' }}
                  </td>

                  <!-- term # (editable) -->
                  <td pEditableColumn>
                    <p-cellEditor>
                      <ng-template #output>{{ row.jsTermNumber }}</ng-template>
                      <ng-template #input>
                        <p-inputNumber [(ngModel)]="row.jsTermNumber"></p-inputNumber>
                      </ng-template>
                    </p-cellEditor>
                  </td>

                  <!-- payment amount (editable) -->
                  <td pEditableColumn>
                    <p-cellEditor>
                      <ng-template #output>{{ row.jsPaymentAmount.toFixed(2) }}</ng-template>
                      <ng-template #input>
                        <p-inputNumber
                          [(ngModel)]="row.jsPaymentAmount"
                          mode="decimal"
                          locale="en-US"
                          [minFractionDigits]="2"
                          [maxFractionDigits]="2"
                        ></p-inputNumber>
                      </ng-template>
                    </p-cellEditor>
                  </td>

                  <!-- ACTIONS -->
                  <td class="text-center" style="width: 9rem">
                    <div class="flex items-center justify-center gap-2">
                      <!-- view mode -->
                      <button
                        *ngIf="!editing"
                        pButton
                        pRipple
                        text
                        rounded
                        severity="secondary"
                        pInitEditableRow
                        icon="pi pi-pencil"
                        (click)="onTpaEditInit(row)"
                        pTooltip="Edit row"
                      ></button>

                      <button
                        *ngIf="!editing"
                        pButton
                        pRipple
                        text
                        rounded
                        severity="danger"
                        icon="pi pi-trash"
                        (click)="removeTermPaymentAmountOverride(ri)"
                        pTooltip="Remove row"
                      ></button>

                      <!-- edit mode -->
                      <button
                        *ngIf="editing"
                        pButton
                        pRipple
                        rounded
                        severity="success"
                        pSaveEditableRow
                        icon="pi pi-check"
                        (click)="onTpaEditSave(row)"
                        pTooltip="Save"
                      ></button>

                      <button
                        *ngIf="editing"
                        pButton
                        pRipple
                        rounded
                        severity="secondary"
                        pCancelEditableRow
                        icon="pi pi-times"
                        (click)="onTpaEditCancel(row, ri)"
                        pTooltip="Cancel"
                      ></button>
                    </div>
                  </td>
                </tr>
              </ng-template>
            </p-table>

            <div class="p-mt-2">
              <p-button
                class="pr-2"
                label="Add New Term Row"
                icon="pi pi-plus"
                (click)="addTermPaymentAmountOverride()"
              ></p-button>
              <p-button
                severity="info"
                label="Re-Sort"
                icon="pi pi-refresh"
                (click)="refreshSortForTermPaymentAmountOverride()"
              ></p-button>

              <p-button
                severity="danger"
                label="Remove All"
                icon="pi pi-trash"
                (click)="removeAllTermPaymentAmounts()"
              ></p-button>
            </div>
          </div>
        </p-accordion-content>
      </p-accordion-panel>

      <!-- Change Payment Date -->
      <p-accordion-panel value="changePaymentDates">
        <p-accordion-header>
          <div>
            <p-badge
              class="mr-4"
              badgeSize="xlarge"
              [severity]="lendPeak.amortization.changePaymentDates.length > 0 ? 'contrast' : 'secondary'"
              [value]="lendPeak.amortization.changePaymentDates.length"
            />
            Change Payment Date
          </div>
        </p-accordion-header>
        <p-accordion-content>
          <div class="p-fluid">
            <!-- CHANGE-PAYMENT DATE TABLE -->
            <p-table
              [value]="lendPeak!.amortization.changePaymentDates.all"
              dataKey="termNumber"
              editMode="row"
              class="p-datatable p-component"
            >
              <!-- HEADER -->
              <ng-template #header>
                <tr>
                  <th style="width: 3rem">
                    <p-toggleswitch
                      [(ngModel)]="cpdMasterActive"
                      (ngModelChange)="toggleAllChangePaymentDates($event)"
                    ></p-toggleswitch>
                  </th>
                  <th>Period Start</th>
                  <th>Period End</th>
                  <th>Term&nbsp;#</th>
                  <th>Original End Date</th>
                  <th>New End Date</th>
                  <th style="width: 9rem">Actions</th>
                </tr>
              </ng-template>

              <!-- BODY -->
              <ng-template #body let-row let-editing="editing" let-ri="rowIndex">
                <tr
                  [pEditableRow]="row"
                  [ngClass]="{
                    'bg-red-50': lendPeak!.amortization.changePaymentDates.isDuplicateTermNumber(row.termNumber),
                    'opacity-40': !row.active,
                  }"
                >
                  <!-- row toggle -->
                  <td>
                    <p-toggleswitch [(ngModel)]="row.active" (ngModelChange)="onInputChange($event)"></p-toggleswitch>
                  </td>

                  <!-- Dates from repayment schedule (read-only) -->
                  <td>
                    {{ getStartDateForTerm(row.termNumber).toString() | date: 'yyyy-MM-dd' }}
                  </td>
                  <td>
                    {{ getEndDateForTerm(row.termNumber).toString() | date: 'yyyy-MM-dd' }}
                  </td>

                  <!-- Term # (editable) -->
                  <td pEditableColumn>
                    <p-cellEditor>
                      <ng-template #output>{{ row.termNumber }}</ng-template>
                      <ng-template #input>
                        <p-inputNumber [(ngModel)]="row.termNumber"></p-inputNumber>
                      </ng-template>
                    </p-cellEditor>
                  </td>

                  <!-- Old Date (editable) -->
                  <td>
                    <ng-container *ngIf="row.originalEndDate; else noDate">
                      {{ row.originalEndDate.toString() | date: 'yyyy-MM-dd' }}
                    </ng-container>
                    <ng-template #noDate>N/A</ng-template>
                  </td>

                  <!-- New Date (editable) -->
                  <td pEditableColumn>
                    <p-cellEditor>
                      <ng-template #output>
                        {{ row.jsNewDate | date: 'yyyy-MM-dd' }}
                      </ng-template>
                      <ng-template #input>
                        <p-datepicker
                          [(ngModel)]="row.jsNewDate"
                          dateFormat="yy-mm-dd"
                          showIcon
                          appendTo="body"
                        ></p-datepicker>
                      </ng-template>
                    </p-cellEditor>
                  </td>

                  <!-- ACTIONS -->
                  <td class="text-center" style="width: 9rem">
                    <div class="flex items-center justify-center gap-2">
                      <!-- view mode -->
                      <button
                        *ngIf="!editing"
                        pButton
                        pRipple
                        text
                        rounded
                        severity="secondary"
                        pInitEditableRow
                        icon="pi pi-pencil"
                        (click)="onCpdEditInit(row)"
                        pTooltip="Edit row"
                      ></button>

                      <button
                        *ngIf="!editing"
                        pButton
                        pRipple
                        text
                        rounded
                        severity="danger"
                        icon="pi pi-trash"
                        (click)="removeChangePaymentDate(ri)"
                        pTooltip="Remove row"
                      ></button>

                      <!-- edit mode -->
                      <button
                        *ngIf="editing"
                        pButton
                        pRipple
                        rounded
                        severity="success"
                        pSaveEditableRow
                        icon="pi pi-check"
                        (click)="onCpdEditSave(row)"
                        pTooltip="Save"
                      ></button>

                      <button
                        *ngIf="editing"
                        pButton
                        pRipple
                        rounded
                        severity="secondary"
                        pCancelEditableRow
                        icon="pi pi-times"
                        (click)="onCpdEditCancel(row, ri)"
                        pTooltip="Cancel"
                      ></button>
                    </div>
                  </td>
                </tr>
              </ng-template>
            </p-table>

            <div class="p-mt-2">
              <p-button
                class="pr-2"
                label="Add Change Payment Date Row"
                icon="pi pi-plus"
                (click)="addNewChangePaymentTermRow()"
              ></p-button>
              <p-button
                severity="info"
                label="Re-Sort"
                icon="pi pi-refresh"
                (click)="refreshSortForChangePaymentDates()"
              ></p-button>
            </div>
          </div>
        </p-accordion-content>
      </p-accordion-panel>

      <!-- Pre Bill Day Term -->
      <p-accordion-panel value="preBillDayTerm">
        <p-accordion-header>
          <div>
            <p-badge
              class="mr-4"
              badgeSize="xlarge"
              [severity]="lendPeak.amortization.preBillDays.hasCustom ? 'contrast' : 'secondary'"
              [value]="lendPeak.amortization.preBillDays.allCustom.length"
            />
            Pre Bill Day Term
          </div>
        </p-accordion-header>
        <p-accordion-content>
          <div class="p-fluid">
            <!-- DSI Notice -->
            <p-message 
              *ngIf="lendPeak.billingModel === 'dailySimpleInterest'" 
              severity="info"
              class="mb-3"
              text="Pre-Bill Days are not applicable for Daily Simple Interest (DSI) loans. Bills are generated based on payment activity."
            />
            <!-- PRE-BILL DAY TERM TABLE -->
            <p-table
              [value]="lendPeak!.amortization.preBillDays.allCustom"
              dataKey="termNumber"
              editMode="row"
              class="p-datatable p-component"
            >
              <!-- HEADER -->
              <ng-template #header>
                <tr>
                  <th style="width: 3rem">
                    <p-toggleswitch
                      [(ngModel)]="pbdMasterActive"
                      (ngModelChange)="toggleAllPreBillDays($event)"
                    ></p-toggleswitch>
                  </th>
                  <th>Period Start</th>
                  <th>Period End</th>
                  <th>Term&nbsp;#</th>
                  <th>Days</th>
                  <th style="width: 9rem">Actions</th>
                </tr>
              </ng-template>

              <!-- BODY -->
              <ng-template #body let-row let-editing="editing" let-ri="rowIndex">
                <tr [pEditableRow]="row" [ngClass]="{ 'opacity-40': !row.active }">
                  <!-- row toggle -->
                  <td>
                    <p-toggleswitch [(ngModel)]="row.active" (ngModelChange)="onInputChange($event)"></p-toggleswitch>
                  </td>

                  <!-- period dates (read-only) -->
                  <td>
                    {{ getStartDateForTerm(row.termNumber).toString() | date: 'yyyy-MM-dd' }}
                  </td>
                  <td>
                    {{ getEndDateForTerm(row.termNumber).toString() | date: 'yyyy-MM-dd' }}
                  </td>

                  <!-- term # (editable) -->
                  <td pEditableColumn>
                    <p-cellEditor>
                      <ng-template #output>{{ row.termNumber }}</ng-template>
                      <ng-template #input>
                        <p-inputNumber [(ngModel)]="row.termNumber"></p-inputNumber>
                      </ng-template>
                    </p-cellEditor>
                  </td>

                  <!-- days (editable) -->
                  <td pEditableColumn>
                    <p-cellEditor>
                      <ng-template #output>{{ row.preBillDays }}</ng-template>
                      <ng-template #input>
                        <p-inputNumber [(ngModel)]="row.preBillDays"></p-inputNumber>
                      </ng-template>
                    </p-cellEditor>
                  </td>

                  <!-- ACTIONS -->
                  <td class="text-center" style="width: 9rem">
                    <div class="flex items-center justify-center gap-2">
                      <!-- view mode -->
                      <button
                        *ngIf="!editing"
                        pButton
                        pRipple
                        text
                        rounded
                        severity="secondary"
                        pInitEditableRow
                        icon="pi pi-pencil"
                        (click)="onPbdEditInit(row)"
                        pTooltip="Edit row"
                      ></button>

                      <button
                        *ngIf="!editing"
                        pButton
                        pRipple
                        text
                        rounded
                        severity="danger"
                        icon="pi pi-trash"
                        (click)="removePreBillDayTerm(ri)"
                        pTooltip="Remove row"
                      ></button>

                      <!-- edit mode -->
                      <button
                        *ngIf="editing"
                        pButton
                        pRipple
                        rounded
                        severity="success"
                        pSaveEditableRow
                        icon="pi pi-check"
                        (click)="onPbdEditSave(row)"
                        pTooltip="Save"
                      ></button>

                      <button
                        *ngIf="editing"
                        pButton
                        pRipple
                        rounded
                        severity="secondary"
                        pCancelEditableRow
                        icon="pi pi-times"
                        (click)="onPbdEditCancel(row, ri)"
                        pTooltip="Cancel"
                      ></button>
                    </div>
                  </td>
                </tr>
              </ng-template>
            </p-table>

            <div class="p-mt-2">
              <p-button label="Add New Term Row" icon="pi pi-plus" (click)="addPrebillDayTermRow()"></p-button>

              <p-button
                severity="danger"
                label="Remove All"
                icon="pi pi-trash"
                (click)="removeAllPreBillDayOverride()"
              ></p-button>
            </div>
          </div>
        </p-accordion-content>
      </p-accordion-panel>

      <!-- Due Bill Day Term -->
      <p-accordion-panel value="dueBillDayTerm">
        <p-accordion-header>
          <div>
            <p-badge
              class="mr-4"
              badgeSize="xlarge"
              [severity]="lendPeak.amortization.dueBillDays.hasCustom ? 'contrast' : 'secondary'"
              [value]="lendPeak.amortization.dueBillDays.allCustom.length"
            />
            Due Bill Day Term
          </div>
        </p-accordion-header>

        <p-accordion-content>
          <div class="p-fluid">
            <!-- DSI Notice -->
            <p-message 
              *ngIf="lendPeak.billingModel === 'dailySimpleInterest'" 
              severity="info"
              class="mb-3"
              text="Due Days are not applicable for Daily Simple Interest (DSI) loans. Bills are generated based on payment activity."
            />
            <!-- DUE-BILL DAY TERM TABLE -->
            <p-table
              [value]="lendPeak!.amortization.dueBillDays.allCustom"
              dataKey="termNumber"
              editMode="row"
              class="p-datatable p-component"
            >
              <!-- HEADER -->
              <ng-template #header>
                <tr>
                  <th style="width: 3rem">
                    <p-toggleswitch
                      [(ngModel)]="dbdMasterActive"
                      (ngModelChange)="toggleAllDueBillDays($event)"
                    ></p-toggleswitch>
                  </th>
                  <th>Period Start</th>
                  <th>Period End</th>
                  <th>Term&nbsp;#</th>
                  <th>Days&nbsp;After&nbsp;End</th>
                  <th style="width: 9rem">Actions</th>
                </tr>
              </ng-template>

              <!-- BODY -->
              <ng-template #body let-row let-editing="editing" let-ri="rowIndex">
                <tr
                  [pEditableRow]="row"
                  [ngClass]="{
                    'bg-red-50': lendPeak!.amortization.dueBillDays.isDuplicateTermNumber(row.termNumber),
                    'opacity-40': !row.active,
                  }"
                >
                  <!-- row toggle -->
                  <td>
                    <p-toggleswitch [(ngModel)]="row.active" (ngModelChange)="onInputChange($event)"></p-toggleswitch>
                  </td>

                  <!-- Period dates (read-only) -->
                  <td>
                    {{ getStartDateForTerm(row.termNumber).toString() | date: 'yyyy-MM-dd' }}
                  </td>
                  <td>
                    {{ getEndDateForTerm(row.termNumber).toString() | date: 'yyyy-MM-dd' }}
                  </td>

                  <!-- Term # (editable) -->
                  <td pEditableColumn>
                    <p-cellEditor>
                      <ng-template #output>{{ row.termNumber }}</ng-template>
                      <ng-template #input>
                        <p-inputNumber [(ngModel)]="row.termNumber"></p-inputNumber>
                      </ng-template>
                    </p-cellEditor>
                  </td>

                  <!-- Days after period end (editable) -->
                  <td pEditableColumn>
                    <p-cellEditor>
                      <ng-template #output>{{ row.daysDueAfterPeriodEnd }}</ng-template>
                      <ng-template #input>
                        <p-inputNumber [(ngModel)]="row.daysDueAfterPeriodEnd"></p-inputNumber>
                      </ng-template>
                    </p-cellEditor>
                  </td>

                  <!-- ACTIONS -->
                  <td class="text-center" style="width: 9rem">
                    <div class="flex items-center justify-center gap-2">
                      <!-- view mode -->
                      <button
                        *ngIf="!editing"
                        pButton
                        pRipple
                        text
                        rounded
                        severity="secondary"
                        pInitEditableRow
                        icon="pi pi-pencil"
                        (click)="onDbdEditInit(row)"
                        pTooltip="Edit row"
                      ></button>

                      <button
                        *ngIf="!editing"
                        pButton
                        pRipple
                        text
                        rounded
                        severity="danger"
                        icon="pi pi-trash"
                        (click)="removeDueBillDayTerm(ri)"
                        pTooltip="Remove row"
                      ></button>

                      <!-- edit mode -->
                      <button
                        *ngIf="editing"
                        pButton
                        pRipple
                        rounded
                        severity="success"
                        pSaveEditableRow
                        icon="pi pi-check"
                        (click)="onDbdEditSave(row)"
                        pTooltip="Save"
                      ></button>

                      <button
                        *ngIf="editing"
                        pButton
                        pRipple
                        rounded
                        severity="secondary"
                        pCancelEditableRow
                        icon="pi pi-times"
                        (click)="onDbdEditCancel(row, ri)"
                        pTooltip="Cancel"
                      ></button>
                    </div>
                  </td>
                </tr>
              </ng-template>
            </p-table>

            <!-- ── Action buttons under table ──────────────────────────────── -->
            <div class="p-mt-2">
              <p-divider></p-divider>
              <p-button
                class="pr-2"
                label="Add New Term Row"
                icon="pi pi-plus"
                (click)="addDueBillDayTermRow()"
              ></p-button>
              <p-button
                severity="info"
                label="Re-Sort"
                icon="pi pi-refresh"
                (click)="refreshSortForDueBillDays()"
              ></p-button>
            </div>
          </div>
        </p-accordion-content>
      </p-accordion-panel>
      <!-- Balance Modifications -->
      <p-accordion-panel value="balanceModifications">
        <p-accordion-header>
          <div>
            <p-badge
              class="mr-4"
              badgeSize="xlarge"
              [severity]="lendPeak.amortization.balanceModifications.all.length > 0 ? 'contrast' : 'secondary'"
              [value]="lendPeak.amortization.balanceModifications.all.length"
            />
            Balance Modifications
          </div>
        </p-accordion-header>
        <p-accordion-content>
          <div class="grid">
            <div class="col-12">
              <p-table [value]="lendPeak.amortization.balanceModifications.all">
                <ng-template pTemplate="header">
                  <tr>
                    <th style="width: 10%">Date</th>
                    <th style="width: 10%">Type</th>
                    <th style="width: 10%">Amount</th>
                    <th style="width: 10%">Unused Amount</th>
                    <th style="width: 10%">System Generated</th>
                    <th style="width: 40%">Description</th>
                    <th style="width: 20%">Actions</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-balanceModification let-i="rowIndex">
                  <tr>
                    <!-- Date -->
                    <td>
                      <p-datepicker
                        [(ngModel)]="balanceModification.jsDate"
                        dateFormat="yy-mm-dd"
                        inputId="balanceModificationDate-{{ i }}"
                        showIcon
                        (ngModelChange)="balanceModificationChanged()"
                        [disabled]="balanceModification.isSystemModification"
                        appendTo="body"
                      ></p-datepicker>
                    </td>
                    <!-- Type -->
                    <td>
                      <p-select
                        [(ngModel)]="balanceModification.type"
                        inputId="balanceModificationType-{{ i }}"
                        [options]="balanceIncreaseType"
                        placeholder="Select a type"
                        (ngModelChange)="balanceModificationChanged()"
                        [disabled]="balanceModification.isSystemModification"
                      ></p-select>
                    </td>
                    <!-- Amount -->
                    <td>
                      <p-inputgroup>
                        <p-inputgroup-addon>$</p-inputgroup-addon>
                        <p-inputNumber
                          [(ngModel)]="balanceModification.jsAmount"
                          name="balanceModificationAmount-{{ i }}"
                          mode="decimal"
                          [minFractionDigits]="2"
                          [maxFractionDigits]="2"
                          locale="en-US"
                          (ngModelChange)="balanceModificationChanged()"
                          [disabled]="balanceModification.isSystemModification"
                        ></p-inputNumber>
                      </p-inputgroup>
                    </td>
                    <!-- Unused Amount -->
                    <td>
                      <p-inputgroup>
                        <p-inputgroup-addon>$</p-inputgroup-addon>
                        <p-inputNumber
                          [disabled]="true"
                          [(ngModel)]="balanceModification.jsUnusedAmount"
                          inputId="balanceModificationAmount-{{ i }}"
                          mode="decimal"
                          [minFractionDigits]="2"
                          [maxFractionDigits]="2"
                          locale="en-US"
                        ></p-inputNumber>
                      </p-inputgroup>
                    </td>
                    <!-- System Generated -->
                    <td>
                      <span>{{ balanceModification.isSystemModification ? 'Yes' : 'No' }}</span>
                    </td>
                    <!-- Description -->
                    <td>
                      <input
                        id="balanceModificationDescription-{{ i }}"
                        style="width: 100%"
                        pInputText
                        type="text"
                        [(ngModel)]="balanceModification.description"
                        name="balanceModificationDescription-{{ i }}"
                        [disabled]="balanceModification.isSystemModification"
                      />
                    </td>
                    <!-- Remove Button -->
                    <td>
                      <p-button
                        icon="pi pi-trash"
                        class="p-button-rounded"
                        severity="danger"
                        (click)="deleteBalanceModificationRow(i)"
                        [disabled]="balanceModification.isSystemModification"
                      ></p-button>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
              <div class="p-mt-2">
                <p-button
                  label="Add Balance Modification Row"
                  icon="pi pi-plus"
                  (click)="addBalanceModificationRow()"
                ></p-button>
              </div>
            </div>
          </div>
        </p-accordion-content>
      </p-accordion-panel>
      <!-- Fees That Apply to All Terms -->
      <p-accordion-panel value="feesForAllTerms">
        <p-accordion-header>
          <div>
            <p-badge
              class="mr-4"
              badgeSize="xlarge"
              [severity]="lendPeak.amortization.feesForAllTerms.length > 0 ? 'contrast' : 'secondary'"
              [value]="lendPeak.amortization.feesForAllTerms.length"
            />
            Fees That Apply to All Terms
          </div>
        </p-accordion-header>
        <p-accordion-content>
          <div class="p-fluid">
            <p-table
              [value]="lendPeak!.amortization.feesForAllTerms.all"
              dataKey="id"
              editMode="row"
              class="p-datatable p-component"
              *ngIf="lendPeak.amortization.feesForAllTerms.length > 0"
            >
              <ng-template #header>
                <tr>
                  <th style="width: 3rem">
                    <p-toggleswitch
                      [(ngModel)]="ffaMasterActive"
                      (ngModelChange)="toggleAllFeesForAllTerms($event)"
                    ></p-toggleswitch>
                  </th>
                  <th>Type</th>
                  <th>Amount / Percentage</th>
                  <th>Based On</th>
                  <th>Description</th>
                  <th style="width: 9rem">Actions</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-row let-editing="editing" let-ri="rowIndex">
                <tr [pEditableRow]="row" [ngClass]="{ 'opacity-40': !row.active }">
                  <td>
                    <p-toggleswitch [(ngModel)]="row.active" (ngModelChange)="onInputChange($event)"></p-toggleswitch>
                  </td>
                  <td pEditableColumn>
                    <p-cellEditor>
                      <ng-template #output>{{ row.type }}</ng-template>
                      <ng-template #input>
                        <p-select
                          [(ngModel)]="row.type"
                          [options]="[
                            { label: 'Fixed', value: 'fixed' },
                            { label: 'Percentage', value: 'percentage' },
                          ]"
                          appendTo="body"
                        ></p-select>
                      </ng-template>
                    </p-cellEditor>
                  </td>
                  <td pEditableColumn>
                    <p-cellEditor>
                      <ng-template #output>
                        {{
                          row.type === 'fixed'
                            ? (row.jsAmount | number: '1.2-2')
                            : (row.jsPercentage | percent: '1.2-2')
                        }}
                      </ng-template>
                      <ng-template #input>
                        <ng-container *ngIf="row.type === 'fixed'">
                          <p-inputNumber
                            [(ngModel)]="row.jsAmount"
                            mode="currency"
                            currency="USD"
                            locale="en-US"
                          ></p-inputNumber>
                        </ng-container>
                        <ng-container *ngIf="row.type === 'percentage'">
                          <p-inputNumber
                            [(ngModel)]="row.jsPercentage"
                            mode="decimal"
                            minFractionDigits="2"
                            suffix="%"
                          ></p-inputNumber>
                        </ng-container>
                      </ng-template>
                    </p-cellEditor>
                  </td>
                  <td pEditableColumn>
                    <p-cellEditor>
                      <ng-template #output>{{ row.basedOn }}</ng-template>
                      <ng-template #input>
                        <p-select
                          [disabled]="row.type !== 'percentage'"
                          [(ngModel)]="row.basedOn"
                          [options]="[
                            { label: 'Interest', value: 'interest' },
                            { label: 'Principal', value: 'principal' },
                            { label: 'Total Payment', value: 'totalPayment' },
                          ]"
                          appendTo="body"
                        ></p-select>
                      </ng-template>
                    </p-cellEditor>
                  </td>
                  <td pEditableColumn>
                    <p-cellEditor>
                      <ng-template #output>{{ row.description }}</ng-template>
                      <ng-template #input>
                        <input pInputText [(ngModel)]="row.description" />
                      </ng-template>
                    </p-cellEditor>
                  </td>
                  <td class="text-center" style="width: 9rem">
                    <div class="flex items-center justify-center gap-2">
                      <button
                        *ngIf="!editing"
                        pButton
                        pRipple
                        text
                        rounded
                        severity="secondary"
                        pInitEditableRow
                        icon="pi pi-pencil"
                        (click)="onFfaEditInit(row)"
                      ></button>
                      <button
                        *ngIf="!editing"
                        pButton
                        pRipple
                        text
                        rounded
                        severity="danger"
                        icon="pi pi-trash"
                        (click)="removeFeeForAllTerms(ri)"
                      ></button>
                      <button
                        *ngIf="editing"
                        pButton
                        pRipple
                        rounded
                        severity="success"
                        pSaveEditableRow
                        icon="pi pi-check"
                        (click)="onFfaEditSave(row)"
                      ></button>
                      <button
                        *ngIf="editing"
                        pButton
                        pRipple
                        rounded
                        severity="secondary"
                        pCancelEditableRow
                        icon="pi pi-times"
                        (click)="onFfaEditCancel(row, ri)"
                      ></button>
                    </div>
                  </td>
                </tr>
              </ng-template>
            </p-table>
            <p-divider></p-divider>
            <div class="p-mt-2">
              <p-button label="Add Fee" icon="pi pi-plus" (click)="addFeeForAllTerms()"></p-button>
            </div>
          </div>
        </p-accordion-content>
      </p-accordion-panel>

      <!-- Fees Per Term -->
      <p-accordion-panel value="feesPerTerm">
        <p-accordion-header>
          <div>
            <p-badge
              class="mr-4"
              badgeSize="xlarge"
              [severity]="lendPeak.amortization.feesPerTerm.length > 0 ? 'contrast' : 'secondary'"
              [value]="lendPeak.amortization.feesPerTerm.length"
            />
            Fees Per Term
          </div>
        </p-accordion-header>
        <p-accordion-content>
          <div class="p-fluid">
            <p-table
              [value]="lendPeak!.amortization.feesPerTerm.flatFeesPerTerm"
              dataKey="fee.id"
              editMode="row"
              class="p-datatable p-component"
              *ngIf="lendPeak.amortization.feesPerTerm.length > 0"
            >
              <ng-template #header>
                <tr>
                  <th style="width: 3rem">
                    <p-toggleswitch
                      [(ngModel)]="fptMasterActive"
                      (ngModelChange)="toggleAllFeesPerTerm($event)"
                    ></p-toggleswitch>
                  </th>
                  <th>Term Number</th>
                  <th>Type</th>
                  <th>Amount / Percentage</th>
                  <th>Based On</th>
                  <th>Description</th>
                  <th style="width: 9rem">Actions</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-row let-editing="editing" let-ri="rowIndex">
                <tr [pEditableRow]="row" [ngClass]="{ 'opacity-40': !row.fee.active }">
                  <td>
                    <p-toggleswitch
                      [(ngModel)]="row.fee.active"
                      (ngModelChange)="onInputChange($event)"
                    ></p-toggleswitch>
                  </td>
                  <td pEditableColumn>
                    <p-cellEditor>
                      <ng-template #output>{{ row.termNumber }}</ng-template>
                      <ng-template #input>
                        <p-inputNumber [(ngModel)]="row.termNumber"></p-inputNumber>
                      </ng-template>
                    </p-cellEditor>
                  </td>
                  <td pEditableColumn>
                    <p-cellEditor>
                      <ng-template #output>{{ row.fee.type }}</ng-template>
                      <ng-template #input>
                        <p-select
                          [(ngModel)]="row.fee.type"
                          [options]="[
                            { label: 'Fixed', value: 'fixed' },
                            { label: 'Percentage', value: 'percentage' },
                          ]"
                          appendTo="body"
                        ></p-select>
                      </ng-template>
                    </p-cellEditor>
                  </td>
                  <td pEditableColumn>
                    <p-cellEditor>
                      <ng-template #output>
                        {{
                          row.fee.type === 'fixed'
                            ? (row.fee.jsAmount | number: '1.2-2')
                            : (row.fee.jsPercentage | percent: '1.2-2')
                        }}
                      </ng-template>
                      <ng-template #input>
                        <ng-container *ngIf="row.fee.type === 'fixed'">
                          <p-inputNumber
                            [(ngModel)]="row.fee.jsAmount"
                            mode="currency"
                            currency="USD"
                            locale="en-US"
                          ></p-inputNumber>
                        </ng-container>
                        <ng-container *ngIf="row.fee.type === 'percentage'">
                          <p-inputNumber
                            [(ngModel)]="row.fee.jsPercentage"
                            mode="decimal"
                            minFractionDigits="2"
                            suffix="%"
                          ></p-inputNumber>
                        </ng-container>
                      </ng-template>
                    </p-cellEditor>
                  </td>
                  <td pEditableColumn>
                    <p-cellEditor>
                      <ng-template #output>{{ row.fee.basedOn }}</ng-template>
                      <ng-template #input>
                        <p-select
                          [disabled]="row.fee.type !== 'percentage'"
                          [(ngModel)]="row.fee.basedOn"
                          [options]="[
                            { label: 'Interest', value: 'interest' },
                            { label: 'Principal', value: 'principal' },
                            { label: 'Total Payment', value: 'totalPayment' },
                          ]"
                          appendTo="body"
                        ></p-select>
                      </ng-template>
                    </p-cellEditor>
                  </td>
                  <td pEditableColumn>
                    <p-cellEditor>
                      <ng-template #output>{{ row.fee.description }}</ng-template>
                      <ng-template #input>
                        <input pInputText [(ngModel)]="row.fee.description" />
                      </ng-template>
                    </p-cellEditor>
                  </td>
                  <td class="text-center" style="width: 9rem">
                    <div class="flex items-center justify-center gap-2">
                      <button
                        *ngIf="!editing"
                        pButton
                        pRipple
                        text
                        rounded
                        severity="secondary"
                        pInitEditableRow
                        icon="pi pi-pencil"
                        (click)="onFptEditInit(row)"
                      ></button>
                      <button
                        *ngIf="!editing"
                        pButton
                        pRipple
                        text
                        rounded
                        severity="danger"
                        icon="pi pi-trash"
                        (click)="removeFeePerTerm(row.termNumber)"
                      ></button>
                      <button
                        *ngIf="editing"
                        pButton
                        pRipple
                        rounded
                        severity="success"
                        pSaveEditableRow
                        icon="pi pi-check"
                        (click)="onFptEditSave(row)"
                      ></button>
                      <button
                        *ngIf="editing"
                        pButton
                        pRipple
                        rounded
                        severity="secondary"
                        pCancelEditableRow
                        icon="pi pi-times"
                        (click)="onFptEditCancel(row, ri)"
                      ></button>
                    </div>
                  </td>
                </tr>
              </ng-template>
            </p-table>
            <p-divider></p-divider>
            <div class="p-mt-2">
              <p-button label="Add Fee" icon="pi pi-plus" (click)="addFeePerTerm()"></p-button>
            </div>
          </div>
        </p-accordion-content>
      </p-accordion-panel>

      <!-- Term Extensions -->
      <p-accordion-panel value="termExtensions" *ngIf="lendPeak?.amortization?.termExtensions">
        <p-accordion-header>
          <div>
            <p-badge
              class="mr-4"
              badgeSize="xlarge"
              [severity]="(lendPeak.amortization.termExtensions.length || 0) > 0 ? 'contrast' : 'secondary'"
              [value]="lendPeak.amortization.termExtensions.length || 0"
            />
            Term Extensions
          </div>
        </p-accordion-header>
        <p-accordion-content>
          <div class="p-fluid">
            <p-table
              [value]="lendPeak.amortization.termExtensions.all || []"
              dataKey="id"
              editMode="row"
              class="p-datatable p-component"
            >
              <ng-template #header>
                <tr>
                  <th style="width: 3rem">
                    <p-toggleswitch
                      [(ngModel)]="termExtensionMasterActive"
                      (ngModelChange)="toggleAllTermExtensions($event)"
                    ></p-toggleswitch>
                  </th>
                  <th>Quantity</th>
                  <th>Date</th>
                  <th>Description</th>
                  <th>EMI Recalculation</th>
                  <th style="width: 9rem">Actions</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-row let-editing="editing" let-ri="rowIndex">
                <tr [pEditableRow]="row" [ngClass]="{ 'opacity-40': !row.active }">
                  <td>
                    <p-toggleswitch [(ngModel)]="row.active" (ngModelChange)="onInputChange($event)"></p-toggleswitch>
                  </td>
                  <td pEditableColumn>
                    <p-cellEditor>
                      <ng-template #output>{{ row.quantity }}</ng-template>
                      <ng-template #input>
                        <p-inputNumber [(ngModel)]="row.quantity"></p-inputNumber>
                      </ng-template>
                    </p-cellEditor>
                  </td>
                  <td pEditableColumn>
                    <p-cellEditor>
                      <ng-template #output>{{ row.date | date: 'yyyy-MM-dd' }}</ng-template>
                      <ng-template #input>
                        <p-calendar [(ngModel)]="row.date" dateFormat="yy-mm-dd" appendTo="body"></p-calendar>
                      </ng-template>
                    </p-cellEditor>
                  </td>
                  <td pEditableColumn>
                    <p-cellEditor>
                      <ng-template #output>{{ row.description }}</ng-template>
                      <ng-template #input>
                        <input pInputText [(ngModel)]="row.description" />
                      </ng-template>
                    </p-cellEditor>
                  </td>
                  <td pEditableColumn>
                    <p-cellEditor>
                      <ng-template #output>
                        {{
                          row.emiRecalculationMode === 'none'
                            ? 'Maintain EMI'
                            : row.emiRecalculationMode === 'fromStart'
                              ? 'Recalculate from Start'
                              : 'Recalculate from Term ' + row.emiRecalculationTerm
                        }}
                        <ng-container
                          *ngIf="row.emiRecalculationMode === 'fromStart' || row.emiRecalculationMode === 'fromTerm'"
                        >
                          <span
                            class="pi pi-info-circle ml-2"
                            pTooltip="If checked, skip-a-pay periods (zero-dollar terms) will be ignored when recalculating EMI. If unchecked, they will be included in the term count."
                            tooltipPosition="top"
                            style="color: #2196f3; cursor: pointer"
                          ></span>
                        </ng-container>
                      </ng-template>
                      <ng-template #input>
                        <p-select
                          [options]="[
                            { label: 'Maintain EMI', value: 'none' },
                            { label: 'Recalculate from Start', value: 'fromStart' },
                            { label: 'Recalculate from Term', value: 'fromTerm' },
                          ]"
                          [(ngModel)]="row.emiRecalculationMode"
                          appendTo="body"
                        ></p-select>
                        <ng-container *ngIf="row.emiRecalculationMode === 'fromTerm'">
                          <label class="ml-2 mr-1">at Term:</label>
                          <p-inputNumber
                            [(ngModel)]="row.emiRecalculationTerm"
                            [min]="1"
                            [max]="lendPeak.amortization.actualTerm || 1"
                            [style.width]="'80px'"
                          ></p-inputNumber>
                        </ng-container>
                        <ng-container
                          *ngIf="row.emiRecalculationMode === 'fromStart' || row.emiRecalculationMode === 'fromTerm'"
                        >
                          <div class="mt-2">
                            <p-checkbox
                              binary="true"
                              [(ngModel)]="row.ignoreSkipTermsForEmiRecalculation"
                              inputId="ignoreSkipTermsForEmiRecalculation-{{ ri }}"
                              [style]="{ 'vertical-align': 'middle' }"
                            ></p-checkbox>
                            <label
                              for="ignoreSkipTermsForEmiRecalculation-{{ ri }}"
                              class="ml-2"
                              style="font-weight: normal; cursor: pointer"
                            >
                              Ignore skip-a-pay periods when recalculating EMI
                            </label>
                            <span
                              class="pi pi-info-circle ml-1"
                              pTooltip="If checked, skip-a-pay periods (zero-dollar terms) will be ignored when recalculating EMI. If unchecked, they will be included in the term count."
                              tooltipPosition="top"
                              style="color: #2196f3; cursor: pointer"
                            ></span>
                          </div>
                        </ng-container>
                        <ng-container *ngIf="row.emiRecalculationMode === 'none'">
                          <div class="text-warning mt-1" style="font-size: 0.9em; color: #f39c12">
                            Maintaining EMI may result in the loan being paid off before the final term. The last
                            scheduled payments may be zero.
                          </div>
                        </ng-container>
                      </ng-template>
                    </p-cellEditor>
                  </td>
                  <td class="text-center" style="width: 9rem">
                    <div class="flex items-center justify-center gap-2">
                      <button
                        *ngIf="!editing"
                        pButton
                        pRipple
                        text
                        rounded
                        severity="secondary"
                        pInitEditableRow
                        icon="pi pi-pencil"
                        (click)="onTermExtensionEditInit(row, ri)"
                        pTooltip="Edit row"
                      ></button>
                      <button
                        *ngIf="!editing"
                        pButton
                        pRipple
                        text
                        rounded
                        severity="danger"
                        icon="pi pi-trash"
                        (click)="removeTermExtension(ri)"
                        pTooltip="Remove row"
                      ></button>
                      <button
                        *ngIf="editing"
                        pButton
                        pRipple
                        rounded
                        severity="success"
                        pSaveEditableRow
                        icon="pi pi-check"
                        (click)="onTermExtensionEditSave(row, ri)"
                        pTooltip="Save"
                      ></button>
                      <button
                        *ngIf="editing"
                        pButton
                        pRipple
                        rounded
                        severity="secondary"
                        pCancelEditableRow
                        icon="pi pi-times"
                        (click)="onTermExtensionEditCancel(row, ri)"
                        pTooltip="Cancel"
                      ></button>
                    </div>
                  </td>
                </tr>
              </ng-template>
            </p-table>
            <div class="p-mt-2">
              <p-button
                class="pr-2"
                label="Add Term Extension"
                icon="pi pi-plus"
                (click)="addTermExtension()"
              ></p-button>
              <p-button
                severity="danger"
                label="Remove All"
                icon="pi pi-trash"
                (click)="removeAllTermExtensions()"
              ></p-button>
            </div>
          </div>
        </p-accordion-content>
      </p-accordion-panel>
    </p-accordion>
  </div>
</div>
